module.exports = __webpack_public_path__ + "media/pandora-garden.0af5f8e8.mp4";